/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".engine-progress[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;z-index:2}"];
export { styles as styles };
